import { EntityMetadataModel, ParameterMetadata } from '../../../api/api';
import { JsonSchemaModel } from '../Models/JsonSchemaModel';
import { getEntityMetadataModelFromJsonSchema } from './EntityMetadataModelConverter';
import { getNonNullSchema } from './JsonSchemaTypes';

export function resolveExpectedObjectType(parameterMetadata: ParameterMetadata, expectedObjectType?: EntityMetadataModel): EntityMetadataModel | undefined {
	if (expectedObjectType) {
		return expectedObjectType;
	}

	const rawSchema = parameterMetadata.expectedType?.typeJsonSchema as JsonSchemaModel | undefined;
	const jsonSchema = rawSchema ? getNonNullSchema(rawSchema) : undefined;
	if (jsonSchema?.type !== 'object') {
		return undefined;
	}

	return getEntityMetadataModelFromJsonSchema(jsonSchema);
}
